<template> 
    <div v-if="parent.isMicroPayent" class="microPayentLayout">
        <div v-if="isAutoRefundPopup" class="autoRefundPopup">
            <div class="rpmain" >
                <div class="close" @click="autoRefundPopupCancel"></div>
                <div class="title" v-html="popAgreementText"></div>

                <div class="countdown">
                    <div class="t">付款剩余时间</div>
                    <div class="timer">
                        <div class="l">{{ cutdowntimerminute }}</div>:<div class="r">{{cutdowntimersecond}}</div>
                    </div>
                </div>
                <div class="btn" v-html="popAgreementBtnText" @click="autoRefundPopupSubmit"></div>
                <div class="prop">
                    <input type="checkbox" v-model="isAgree">
                    <a href="https://jinchan-pay.hexun.com/help/personalHelp/service_rules.html">钱包服务协议</a>、
                    <a href="https://jinchan-pay.hexun.com/help/personalHelp/privacy_rules.html">钱包隐私声明</a>、
                    <a href="https://www.homeway.com.cn/xy/xz.html">用户须知</a>
                </div>
            </div>
        </div>
        <div
          v-if="parent.markeyPage.combinationType=='customerService'&&itemDtail.type=='link' && parent.isMicroPayent
          "
          class="customerServiceMicroPayent"
        >
            <img :src="itemDtail.src" class="img" @click="customerServiceMicroPayentPopupShow" @load="onBackgroundImageLoad" />
        </div>
        <div class="customerServiceMicroPayentPopup" v-if="isCustomerServiceMicroPayent">
            <div class="csmpmain">
                <img src="https://photo28.hexun.com/img/2026/0115/o_af30b2d96a8d4bc3affe263020f45b72.png" class="img" />
                <div class="textlayout">
                    <div class="linkserver" @click="customerServiceMicroPayentBtn">我已支付，点此联系老师</div>
                    <div class="repay" @click="customerServiceMicroPayentRepay">支付遇到问题？重新支付</div>
                    <div class="tellay">
                        客服电话：<a class="tel" @click="telcsmp" href="tel:010-85697400">010-85697400</a><span class="line">|</span>工作时间：<span class="wtime">周一至周五 9:30-18:30</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {  Indicator } from "mint-ui";
export default {
    data() {
        // 存储
        return {
            // 是否是小额支付流程过渡页
            isCustomerServiceMicroPayent:false,
            // 是否显示协议弹窗
            isAutoRefundPopup:false,
            // 是否同意协议checkbox
            isAgree:false,
            // 倒计时定时器,minute
            cutdowntimerminute:'05',
            // 倒计时定时器second
            cutdowntimersecond:'00',
        }
    },
    // 创建
    created() {
        const _this = this;
        _this.autoRefundPopupSubmit = function(){
            _this.isAutoRefundPopup = true;
        }
        _this.autoRefundPopupCancel = function(){
            _this.isAutoRefundPopup = false;
        }
    },
    computed: {
        // 获取token
        invoketoken(){
            const _this = this;
            let token = _this.getUrlParam('invoketoken')
            if(_this.itemDtail._invoketoken&&_this.itemDtail._invoketoken*1>0){
                token = _this.itemDtail._invoketoken
            }
            return token
        },
        /**
         * @description: 是否买过
         * @param {*}
         * @return {*}
         */
        isHasBeenPaidForGroup(){
            const _this = this;
            return _this.itemDtail?._isHasBeenPaidForGroup
        },
        // 顶部文字处理
        popAgreementText(){
            const _this = this;
            let txt = _this.itemDtail?.agreementText
            if(typeof(txt)=='undefined'||txt==''){
                txt = '';
            }
            if(txt.indexOf('{')>-1&&typeof(txt)!='undefined'&&txt!=''){
                txt = txt.replace('{','<span class="font">').replace('}','</span>')
            }
            txt+='<p class="des">已为您锁定福利</p>'
            return txt
        },
        // 按钮文字处理
        popAgreementBtnText(){
            const _this = this;
            let txt = _this.itemDtail?.agreementBtnText
            if(typeof(txt)=='undefined'||txt==''){
                return ''
            }
            if(txt.indexOf('[price]')>-1){
                txt = txt.replace('[price]',_this.itemDtail?._price)
            }
            return txt
        },
        /**
         * @description: 获取当前模块详情
         * @param {*} item
         * @return {*}
         */        
        itemDtail(item) { 
            const _this = this;
            return _this.parent.modelist[0]
        },
        /**
         * @description: 父级
         * @return {*}
         */        
        parent(){return this.$parent},
    },
    watch: {
        // 显示弹窗
        isAutoRefundPopup(a){
            const _this = this;
            if(a){
                _this.cutdowntimerminute = '05'
                _this.cutdowntimersecond= '00'
                clearInterval(_this.cutdowntimer)
                let _time = 5*60*1000;
                _this.cutdowntimer = setInterval(()=>{
                    // 倒计时
                    if(_time>0){
                        _time = _time-1000
                    }else{
                        clearInterval(cutdowntimer)
                    }
                    _this.cutdowntimerminute = parseInt(_time/(60*1000)).toString().padStart(2, '0');
                    _this.cutdowntimersecond = parseInt((_time%(60*1000))/1000).toString().padStart(2, '0');
                },1000)
                _this._sendTrack("view_pay_confirm_popup", {
                    page_title:'营销课落地页',
                    page_name: "投放页面",
                    from_source: "h5",
                    product_id: _this.itemDtail.groupId,
                    partner_id:_this.parent.markeyPage.partnerId,
                    url:location.href,
                    campaign_id:_this.parent.id
                });
            }else{
                clearInterval(_this.cutdowntimer)
            }
        }
    },
    methods: {
        /**
         * @description: 页面进入检测是否购买过
         * @param {*}
         * @return {*}
         */
        isPayendForOnload(callback){
            const _this = this;
            if(_this.invoketoken!=null){
                var numb=0
                function autopay(){
                    _this.isHasBeenPaidForOrder().then(res=>{
                        numb = numb+1;
                        // 0：未扫码，1：支付中，<订单号>：支付完成 -1 获取支付状态失败
                        if (res&&res.payResult * 1 > 1) {
                            clearInterval(timer)
                            // 支付完成
                            console.log("支付状态查询成功：已支付");
                            // 已支付
                            _this.$parent.modelist[0]._isHasBeenPaidForGroup = true;
                            _this.customerServiceMicroPayentPopupHide();
                            _this.parent.isMicroPayent=false;
                            _this.parent.customerservice(_this.itemDtail)

                        }
                    })
                }
                var timer = setInterval(()=>{
                    if(numb>=3){
                        clearInterval(timer)
                        callback&&callback()
                    }else{
                        autopay()
                    }
                },800)
            }else{
                _this.customerServiceMicroPayentSub()
                callback&&callback()
            }
        },
        /**
         * @description: 双按钮统一处理
         * @return {*}
         */
        customerServiceMicroPayentSub(btnName){
            const _this = this;
            if(!_this.parent.islogin){
                if (_this.parent.isloaddysdk && _this.itemDtail.dyAutoLogin) {
                    _this.parent.$refs.dysdk.init(_this.itemDtail,function(){
                        console.log('用户取消抖音授权操作')
                    });
                }
                _this.popupLogin().then((_rs)=>{
                    if(_rs){
                        _this.customerServiceMicroPayentSub();
                    }
                })
                return;
            }
            // 关闭小额订单状态
            _this.parent.isMicroPayent=false;
            // // 如果已经支付了直接跳转客服
            // if(_this.isHasBeenPaidForGroup){
            //     // 走客服逻辑
            //     _this.parent.customerservice(_this.itemDtail)
            // }else{

            // }
            // 没支付再次查询支付状态，因为页面进入和点击有延迟
            Indicator.open({
                text: '正在查询支付信息即将为您跳转...',
                spinnerType: 'fading-circle'
            });
            // 说明没有下过订单，则直接查询
            if(_this.invoketoken==null){
                _this.isHasBeenPaidForCsp().then(res=>{
                    if(res){
                        // 已支付
                        _this.$parent.modelist[0]._isHasBeenPaidForGroup = true;
                        // 走客服逻辑
                        _this.parent.customerservice(_this.itemDtail);
                        _this._sendTrack("click_pay_return", {
                            page_title:'营销课落地页',
                            page_name: "投放页面",
                            from_source: "h5",
                            button_name: btnName,
                            page_status:'confirm_page',
                            product_id: _this.itemDtail.groupId,
                            partner_id:_this.parent.markeyPage.partnerId,
                            url:location.href,
                            campaign_id:_this.parent.id
                        });
                    }else{
                        _this.parent.modelist[0].type="payfor";
                        // 没支付走快捷支付
                        _this.payfor()
                        _this._sendTrack("click_pay_return", {
                            page_title:'营销课落地页',
                            page_name: "投放页面",
                            from_source: "h5",
                            button_name: btnName,
                            page_status:'unfinished_popup',
                            product_id: _this.itemDtail.groupId,
                            partner_id:_this.parent.markeyPage.partnerId,
                            url:location.href,
                            campaign_id:_this.parent.id
                        });
                    }
                    Indicator.close()
                })
            }else{
                // 已经下过订单，需要继续支付此订单
                _this.isHasBeenPaidForOrder().then(res=>{
                    // 0：未扫码，1：支付中，<订单号>：支付完成 -1 获取支付状态失败
                    if (res&&res.payResult * 1 > 1) {
                        // 支付完成
                        console.log("支付状态查询成功：已支付");
                        // 已支付
                        _this.$parent.modelist[0]._isHasBeenPaidForGroup = true;
                        _this.parent.customerservice(_this.itemDtail)
                        _this._sendTrack("click_pay_return", {
                            page_title:'营销课落地页',
                            page_name: "投放页面",
                            from_source: "h5",
                            button_name: btnName,
                            page_status:'unfinished_popup',
                            product_id: _this.itemDtail.groupId,
                            partner_id:_this.parent.markeyPage.partnerId,
                            url:location.href,
                            campaign_id:_this.parent.id
                        });
                    }else if(res.orderid&&res.orderid*1){
                        // 没支付走快捷继续支付
                        _this.payforOrder(res.orderid)
                        _this._sendTrack("click_pay_return", {
                            page_title:'营销课落地页',
                            page_name: "投放页面",
                            from_source: "h5",
                            button_name: btnName,
                            page_status:'unfinished_popup',
                            product_id: _this.itemDtail.groupId,
                            partner_id:_this.parent.markeyPage.partnerId,
                            url:location.href,
                            campaign_id:_this.parent.id
                        });
                    }else{
                        // 没支付走快捷支付重新下单
                        _this.parent.modelist[0].type="payfor";
                        _this.payfor()
                        _this._sendTrack("click_pay_return", {
                            page_title:'营销课落地页',
                            page_name: "投放页面",
                            from_source: "h5",
                            button_name: btnName,
                            page_status:'unfinished_popup',
                            product_id: _this.itemDtail.groupId,
                            partner_id:_this.parent.markeyPage.partnerId,
                            url:location.href,
                            campaign_id:_this.parent.id
                        });
                    }
                    Indicator.close()
                })
            }
        },
        /**
         * @description: 拨打电话埋点
         * @return {*}
         */        
        telcsmp(){
            const _this = this;
            _this._sendTrack("click_pay_return", {
                page_title:'营销课落地页',
                page_name: "投放页面",
                from_source: "h5",
                button_name:'cs_phone',
                page_status:_this.isHasBeenPaidForGroup?'confirm_page':'unfinished_popup',
                product_id: _this.itemDtail.groupId,
                partner_id:_this.parent.markeyPage.partnerId,
                url:location.href,
                campaign_id:_this.parent.id
            });
        },
        /**
         * @description: 重新支付
         * @return {*}
         */        
        customerServiceMicroPayentRepay(){
            const _this = this;
            _this.customerServiceMicroPayentSub('repay')
        },
        /**
         * @description: 联系老师按钮点击
         * @return {*}
         */        
        customerServiceMicroPayentBtn(){
            const _this = this;
            _this.customerServiceMicroPayentSub('paid_contact')
        },
        //背景图加载完成后
        onBackgroundImageLoad(){
            const _this = this;
            if(_this.parent.isMicroPayent&&_this.parent.markeyPage.combinationType=='customerService'){
                _this.customerServiceMicroPayentPopupShow();
                _this._sendTrack("view_pay_return", {
                    page_title:'营销课落地页',
                    page_name: "投放页面",
                    from_source: "h5",
                    product_id: _this.itemDtail.groupId,
                    partner_id:_this.parent.markeyPage.partnerId,
                    url:location.href,
                    campaign_id:_this.parent.id
                });
                _this.isPayendForOnload()
            }
        },
        /**
         * @description: 弹窗显示
         * @return {*}
         */        
        customerServiceMicroPayentPopupHide(){
            const _this = this;
            _this.isCustomerServiceMicroPayent = false;
            $('.customerServiceMicroPayentPopup .csmpmain').removeClass('csmpmain-show')
        },
        /**
         * @description: 弹窗显示
         * @return {*}
         */        
        customerServiceMicroPayentPopupShow(){
            const _this = this;
            _this.isCustomerServiceMicroPayent = true;
            setTimeout(()=>{ 
                $('.customerServiceMicroPayentPopup .csmpmain').addClass('csmpmain-show')
            },500)
        },
        /**
         * @description: 登录弹窗要用的贴片，按钮文案
         * @return {*}
         */        
        txtDataParams(params){
            const _this = this;
            const _p = {
                // 链路状态
                conversionLinktype:_this.itemDtail?.conversionLinktype,
                // 登录引导文案
                loginText:_this.itemDtail?.loginText,
                //登录按钮文案   
                loginBtnText:_this.itemDtail?.loginBtnText,
                // 贴片状态
                popup: _this.itemDtail.conversionLinktype == 'noRefund'?false:_this.itemDtail?.popup,
                //贴片文案  
                popupText: _this.itemDtail?.popupText,
                //协议贴片状态  
                agreement: _this.itemDtail.conversionLinktype == 'autoRefund'?true:_this.itemDtail?.agreement,
                //协议贴片文案  
                agreementText: _this.itemDtail?.agreementText,
                //协议按钮文案   
                agreementBtnText: _this.itemDtail?.agreementBtnText,
                // 真是价格
                price:_this.itemDtail?._price,
                // 套餐ID
                groupId:_this.itemDtail?.groupId,
                // 模板ID
                id:_this.itemDtail?.conversionLinktypPopupId?_this.itemDtail?.conversionLinktypPopupId:'',

            }
            if(params){
                return  {..._p,...params}
            }else{
                return _p
            }
        },
        /**
         * @description: 神策基础参数
         * @return {*}
         */        
        scParams(params){
            const _this = this;
            const _p = {
                product_id:_this.itemDtail?.groupId,
                partner_id:_this.parent.markeyPage.partnerId,
                url:location.href,
                campaign_id:_this.parent.id
            }
            if(params){
                return  {..._p,...params}
            }else{
                return _p
            }
        },
        /**
         * @description: 登录
         * @return {*}
         */        
        popupLogin(){ 
            const _this = this;
            const sensorsData = _this.scParams();
            const txtData = _this.txtDataParams();
            // 如果是不退款模式,不显示贴片
            if(_this.itemDtail.conversionLinktype == 'noRefund'){
                txtData.popup=false
            }
            return new Promise((resolve, reject) => { 
                _this.httpToHttps.login({
                    loginSdk:{
                        type:2,
                        sensorsData,
                        txtData
                    }
                }).then(_rs=>{
                    // _rs.islogin = true;
                    if(_rs.islogin){
                        _this.parent.islogin = true
                        _this.parent.userinfo = _rs;
                        _this.parent.modelist[0].userinfo=_rs;
                        _this.parent.modelist[0]._loginAction = true
                        resolve(true)
                    }else{
                        // 登录失败
                        //resolve(false)
                    }
                })
            })
        },
        /**
         * @description: 登录成功回调
         * @param {*} callback
         * @return {*}
         */
        autoRefundPopup(params){
            const _this = this;
            return new Promise((resolve, reject) => {
                _this.autoRefundPopupSubmit = function(){
                    if(_this.isAgree){
                        resolve(true)
                        _this._sendTrack("click_pay_confirm_popup", {
                            page_title:'营销课落地页',
                            page_name: "投放页面",
                            from_source: "h5",
                            button_name:'confirm',
                            product_id: _this.itemDtail.groupId,
                            partner_id:_this.parent.markeyPage.partnerId,
                            url:location.href,
                            campaign_id:_this.parent.id
                        });
                    }else{
                        _this.isAgree = true;
                        _this._sendTrack("click_pay_confirm_popup", {
                            page_title:'营销课落地页',
                            page_name: "投放页面",
                            from_source: "h5",
                            button_name:'agreement_check',
                            product_id: _this.itemDtail.groupId,
                            partner_id:_this.parent.markeyPage.partnerId,
                            url:location.href,
                            campaign_id:_this.parent.id
                        });
                        // 退费模式则自动勾选并且执行操作
                        if(_this.itemDtail.conversionLinktype == "autoRefund"){
                            resolve(true)
                        }
                    }
                    
                }
                _this.autoRefundPopupCancel = function(){
                    _this.isAutoRefundPopup = false;
                    resolve(false)
                    _this._sendTrack("click_pay_confirm_popup", {
                        page_title:'营销课落地页',
                        page_name: "投放页面",
                        from_source: "h5",
                        button_name:'close',
                        product_id: _this.itemDtail.groupId,
                        partner_id:_this.parent.markeyPage.partnerId,
                        url:location.href,
                        campaign_id:_this.parent.id
                    });
                }
                _this.isAutoRefundPopup = params.isopen
            });
        },
        // 弹出用户同意协议弹窗
        popupProConfirm(params){ 
            const _this = this;
            const sensorsData = _this.scParams();
            const txtData = _this.txtDataParams();
            // 自动退款订单执行登录后直接跳转
            if(_this.itemDtail.conversionLinktype == 'autoRefund'&& !_this.itemDtail._loginAction){
                // 自动退款订单
                _this.autoRefundPopup({
                    isopen:true
                }).then(_rs=>{
                    // 成功点击了确认按钮 _rs.islogin false的情况包括关闭了弹窗等其他状态
                    params.callback(_rs)
                })
            }else if(_this.itemDtail.conversionLinktype == 'noRefund'){
                console.log('🚀🚀',sensorsData)
                console.log('🚀🚀',txtData)
                // 不自动退款
                _this.httpToHttps.openHxfkAndFwxy({
                    renderType: "h5Sale",
                    fwxyParams:{
                        groupid:_this.itemDtail.groupId,
                        sensorsData,
                        txtData
                    }
                }).then(_res=>{
                    // 同意协议
                    params.callback(true)
                }).catch(err=>{
                    console.log(err)
                })
            }else{
                params.callback(true)
            }
            // 自动退款流程弹出统一协议
            // MessageBox({
            //     title: '提示',
            //     message: '自动退款流程请确认协议',
            //     showConfirmButton:true,
            //     confirmButtonText:'同意协议支付0.10元'
            // });
        },
        /**
         * @description: 执行继续支付
         * @return {*}
         */        
        payforOrder(oid){
            const _this = this;
            console.log('执行继续支付')
            location.href = `${_this.apilist("setContinuepay")}?orderid=${oid}` 
        },
        /**
         * @description: 执行支付
         * @return {*}
         */
        payfor(url){
            const _this = this;
            // 标记快捷支付订单套餐
            _this.parent.modelist[0].wxpaygroupid = _this.itemDtail.groupId
            _this.parent.fastpayclick(_this.itemDtail)
        },
        /**
         * @description: 检测是否已购买
         * @param {*} params
         * @return {*}
         */
        isHasBeenPaidForCsp(params){
            const _this = this;
            return new Promise((resolve, reject) => {
                _this.parent.isHasBeenPaid({
                    groupid:_this.itemDtail.groupId,
                    isVerification:true,
                    callback(res){
                        // 返回两个集合getpackageinfo:{},getuserordercount:{}
                        if(res.getpackageinfo.respCode=='0'){
                            // 验证是否购买过
                            if (res.getuserordercount.respCode == "0") {
                                // 如果已购买过，则跳转到客服
                                if (res.getuserordercount.result.buytimes * 1 > 0) {
                                    // 如果已经买过执行下一步
                                    resolve(true)
                                } else {
                                    // 未购买过需要弹出协议
                                    resolve(false)
                                }
                            }else{
                                resolve(false)
                            }
                        }else{
                            resolve(false)
                        }
                    }
                })
            })
        },
        /**
         * @description: 检测是否已下过单
         * @return {*}
         */        
        isHasBeenPaidForOrder(){ 
            const _this = this;
            const params = {
                invoketoken: _this.invoketoken, // 订单标识
                needQueryOrderInfo: 1
            };
            return new Promise((resolve, reject) => {
                _this.getData(
                    _this.apilist("getInvoketokenOrderPayed"),
                    function (res) {
                        // 如果已经resolved，不处理响应
                        if (res && res.respCode == 0 && res.result && res.result.payResult) {
                            // 0：未扫码，1：支付中，<订单号>：支付完成
                            resolve(res.result);
                        } else {
                            // API调用失败，继续查询
                            console.log("支付状态查询：API调用失败，继续尝试");
                            resolve(-1);
                        }
                    },
                    params,
                    3000 // 设置API超时时间为2秒
                );
            })
        },
        /**
         * @description: 启动小额1元以下支付流程
         * @param {*} url 支付地址
         * @return {*}
         */
        async init(url){
            // 落地页才用到此函数
            const _this = this;
            // 如果登录了弹出
            if(_this.parent.islogin){
                // 校验是否购买过
                if(_this.isHasBeenPaidForGroup){
                    let fastpaybackurl =
                    _this.itemDtail.fastpaybackurl && _this.itemDtail.fastpaybackurl != ""
                    ? _this.parent.resetutmcampaign(_this.itemDtail.fastpaybackurl, "pay")
                    : location.href;
                    // 买过直接跳转订单回调页面
                    location.href = fastpaybackurl;
                }else{
                    _this.payfor()
                }
            }else{
                _this.popupLogin().then((_rs)=>{
                    if(_rs){
                        _this.parent.evenclick(_this.itemDtail, false);
                    }
                })
            }
        },
    },
}
</script>
<style lang="scss" scoped>
.microPayentLayout{
    .autoRefundPopup{
        position: fixed;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,0.8);
        z-index: 999;
        display: flex;
        align-items: center;
        justify-content: center;
        .rpmain{
            width: 300px;
            height: 400px;
            // https://photo28.hexun.com/img/2026/0109/o_1f90b1956c044fbc8c2b958964ffa4a9.png\https://test-photo28.hexun.com/img/2026/0108/o_e4691a2ea6974e5d9f4a16355904ee0e.png
            background: url('https://photo28.hexun.com/img/2026/0109/o_1f90b1956c044fbc8c2b958964ffa4a9.png') no-repeat center/100% auto;
            position: relative;
            .close{
                position: absolute;
                right: 0;
                top: 0;
                width: 30px;
                height: 30px;
                background:url(https://photo28.hexun.com/img/2026/0120/o_a38036603e5147b3bbb0f2f3aee0c939.png) no-repeat center/25px auto;
                margin: -40px 10px 0 0;
            }
            .title{
                font-size: 16px;
                text-align: center;
                padding: 112px 0 0 0;
                font-weight: 600;
                color:#FF3733;
                height: 202px;
                box-sizing: border-box;
                ::v-deep .font{
                    font-size:46px;
                    color:#FF3733;
                }
                ::v-deep .des{
                    color: #870020;
                    padding: 10px 0 0 0;
                }
            }
            .countdown{
                font-size: 14px;
                display: flex;
                justify-content: center;
                align-items: center;
                height: 96px;
                box-sizing: border-box;
                color: #fff;
                flex-direction: column;
                .timer{
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    font-weight: 600;
                    font-size: 18px;
                    padding: 10px 0 0 0;
                    .l,.r{
                        border-radius: 6.651px;
                        border: 1.425px solid #FF886E;
                        background: #811F0F;
                        box-shadow: 0 0 5.701px 0 rgba(0, 0, 0, 0.25) inset;
                        width: 34px;
                        height: 34px;
                        box-sizing: border-box;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        margin: 0 5px;
                    }
                }
            }
            .btn{
                height: 48px;
                align-items: center;
                justify-content: center;
                display: flex;
                font-size: 16px;
                font-weight: 600;
                color: #750304;
            }
            .prop{
                height: 40px;
                align-items: center;
                justify-content: center;
                display: flex;
                font-size: 12px;
                color: #fff;
                a{
                    color: #fff;
                }
                input{
                    margin: 0 4px;
                }
            }
        }
    }
}
</style>